import { render, staticRenderFns } from "./ModalPageBlocked.vue?vue&type=template&id=a547509c&scoped=true&"
import script from "./ModalPageBlocked.vue?vue&type=script&lang=js&"
export * from "./ModalPageBlocked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a547509c",
  null
  
)

export default component.exports